import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class PrimePurchaseInformation extends Component {
  #section;
  #pending;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#updatePurchaseInformation);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#updatePurchaseInformation);
    this.#pending = null;
  }

  #updatePurchaseInformation = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const pending = event.promise;
    if (!pending) return;
    this.#pending = pending;
    pending.then(({ detail }) => {
      if (!this.isConnected || this.#pending !== pending || !detail?.html) return;
      const next = detail.html.querySelector(`prime-purchase-information[data-block-id="${CSS.escape(this.dataset.blockId)}"]`);
      if (!next) return;
      if (detail.productId && detail.productId !== this.dataset.productId && !detail.newProduct) return;
      this.dataset.productId = next.dataset.productId;
      this.replaceChildren(...next.cloneNode(true).childNodes);
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[prime-purchase-information]', error);
    });
  };
}

class PrimePhoneComparison extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.refs.controls instanceof HTMLElement) this.refs.controls.hidden = false;
  }

  updatedCallback() {
    super.updatedCallback();
    if (this.refs.controls instanceof HTMLElement) this.refs.controls.hidden = false;
    this.compare();
  }

  compare() {
    const selector = this.refs.selector;
    if (!(selector instanceof HTMLSelectElement)) return;
    const template = [...this.querySelectorAll('template[data-comparison-id]')].find(
      (entry) => entry.dataset.comparisonId === selector.value
    );
    if (!(template instanceof HTMLTemplateElement)) return;
    for (const cell of this.querySelectorAll('table [data-comparison-cell]')) {
      const replacement = template.content.querySelector(`[data-comparison-cell="${cell.dataset.comparisonCell}"]`);
      if (replacement) cell.replaceChildren(...replacement.cloneNode(true).childNodes);
    }
    if (this.refs.status instanceof HTMLElement) this.refs.status.textContent = this.refs.status.dataset.message;
  }
}

class PrimeUpgradeGuide extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.refs.controls instanceof HTMLElement) this.refs.controls.hidden = false;
    this.updateGuide();
  }

  updatedCallback() {
    super.updatedCallback();
    if (this.refs.controls instanceof HTMLElement) this.refs.controls.hidden = false;
    this.updateGuide();
  }

  updateGuide() {
    const { selector, results, source, status } = this.refs;
    if (!(selector instanceof HTMLSelectElement) || !(results instanceof HTMLElement)) return;
    const option = selector.selectedOptions[0];
    if (!option || !option.value) {
      results.hidden = true;
      return;
    }
    const previous = option.dataset;
    const hours = Number(previous.battery);
    const display = Number(previous.display);
    const locale = document.documentElement.lang || 'de';
    for (const cell of this.querySelectorAll('[data-old]')) {
      const key = cell.dataset.old;
      let value = key === 'model' ? option.textContent : previous[key] || '';
      if (key === 'display' && Number.isFinite(display) && display > 0) value = `${display.toLocaleString(locale)}″`;
      if (key === 'battery' && Number.isFinite(hours) && hours > 0) value = cell.dataset.format.replace('__value__', hours.toLocaleString(locale));
      cell.textContent = value;
    }
    const benefits = {
      display: display > 0 && Number(this.dataset.display) > display,
      camera: this.dataset.camera?.includes('48 MP') && Number(previous.cameraMp) > 0 && Number(previous.cameraMp) < 48,
      battery: hours > 0 && !this.dataset.secondaryDisplay && Number(this.dataset.battery) > hours,
      connector: previous.connector === 'Lightning' && this.dataset.connector?.includes('USB-C'),
    };
    for (const entry of this.querySelectorAll('[data-benefit]')) entry.hidden = !benefits[entry.dataset.benefit];
    if (source instanceof HTMLAnchorElement) {
      try {
        const url = new URL(previous.source);
        source.href = url.protocol === 'https:' ? url.href : 'https://www.apple.com/de/iphone/compare/';
      } catch {
        source.href = 'https://www.apple.com/de/iphone/compare/';
      }
    }
    results.hidden = false;
    if (status instanceof HTMLElement) status.textContent = status.dataset.message;
  }
}

if (!customElements.get('prime-phone-comparison')) customElements.define('prime-phone-comparison', PrimePhoneComparison);
if (!customElements.get('prime-upgrade-guide')) customElements.define('prime-upgrade-guide', PrimeUpgradeGuide);
if (!customElements.get('prime-purchase-information')) customElements.define('prime-purchase-information', PrimePurchaseInformation);
